export const randomId = (prefix = "") =>
	prefix + (Date.now() * Math.random()).toString(36).replace(/[^a-z]/g, "");
